import { Grid } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { UserRole } from '@synergy/models';

import { ContactDetailPermissionsRoleField } from './contact-detail-permissions-role-field';

export const ContactDetailPermissionsRolesAdmin = () => {
    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.contactsAndOrganizations.contact.portal.admin" />

            <Grid container={true} columnSpacing={2} sx={{ mt: 0 }}>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.Admin} />
                </Grid>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.SuperAdmin} />
                </Grid>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.Sales} />
                </Grid>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.Accounting} />
                </Grid>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.Configuration} />
                </Grid>
                <Grid item={true} xs={6}>
                    <ContactDetailPermissionsRoleField role={UserRole.ImportApi} />
                </Grid>
            </Grid>
        </>
    );
};
